import {MembershipTypes, Roles} from "../Configs/DatabaseConsts";
import {t} from "./i18n";
import {REPORT_ACTIONS} from "../../web/src/components/Reports/ReportHelpers/ReportsConsts";

export const CATEGORY_SELECT = 'CATEGORY_SELECT'
export const USERS_SELECT = 'USERS_SELECT'
export const COACH_SELECT = 'COACH_SELECT'
export const STAFF_SELECT = 'STAFF_SELECT'
export const MESSAGE_TEMPLATE_SELECT = 'MESSAGE_TEMPLATE_SELECT'
export const TASK_TYPES_SELECT = 'TASK_TYPES_SELECT'
export const CUSTOM_FIELD_SELECT = 'CUSTOM_FIELD_SELECT'

export const LEAD_SOURCE_SELECT = 'LEAD_SOURCE_SELECT'
export const LEAD_STATUS_SELECT = 'LEAD_STATUS_SELECT'
export const SPACE_SELECT = 'SPACE_SELECT'
export const LOST_REASONS_SELECT = 'LOST_REASONS_SELECT'
export const ITEMS_SELECT = 'ITEMS_SELECT'
export const SEASONS_SELECT = 'SEASONS_SELECT'
export const NOTE_TEMPLATE_SELECT = 'NOTE_TEMPLATE_SELECT'

export const ONE_TIME_PURCHASE = 'ONE_TIME_PURCHASE'
export const EXISTING_MEMBERSHIP = 'EXISTING_MEMBERSHIP'
export const NO_MEMBERSHIP = 'NO_MEMBERSHIP'

export const ENTER_DEBT = 'ENTER_DEBT'
export const FREE_PURCHASE = 'FREE_PURCHASE'

export const PAYMENT_OPTION = 'PAYMENT_OPTION'
export const PAYMENT_METHOD = 'PAYMENT_METHOD'
export const CVV_AND_INSTALLMENTS = 'CVV_AND_INSTALLMENTS'
export const BILLING_ADDRESS = 'BILLING_ADDRESS'
export const TOKEN_IFRAME = 'TOKEN_IFRAME'

export const SCHEDULE_TYPE = 'schedule'
export const SCHEDULE_TYPE_TC = 'Schedule'
export const AVAILABILITY_TYPE = 'availability'
export const SPACES_TYPE = 'spaces'
export const MIX_TYPE = 'mix'

export const HORIZONTAL = 'horizontal'
export const VERTICAL = 'vertical'
export const SPACE_LIST = 'SPACE_LIST'

export const MIX_WEEKLY = 'MIX_WEEKLY'
export const MIX_WEEKLY_BY_DATE = 'MIX_WEEKLY_BY_DATE'
export const MIX_DAILY = 'MIX_DAILY'
export const SINGLE_SESSION_EDIT_TYPE = 'SINGLE_SESSION_EDIT_TYPE'
export const SERIES_FUTURE_SESSIONS_EDIT_TYPE = 'SERIES_FUTURE_SESSIONS_EDIT_TYPE'

export const LEAD_TYPE = 'lead'
export const USER_TYPE = 'user'
export const USER_TYPE_TC = 'User'
export const AGGREGATOR_TYPE = 'aggregator'
export const STAFF_TYPE = 'coach'

export const CLASS = 'class'
export const APPOINTMENT = 'appointment'
export const WORKSHOP = 'workshop'
export const BLOCKED = 'blocked'
export const HUGIM = 'hugim'

export const TOAST_TYPE = 'toast'
export const PAGE_TYPE = 'page'
export const MESSAGE_TYPE = 'message'
export const NO_MESSAGE_TYPE = 'no_message'

export const ADD_TO_EVENT = 'add_to_event'

export const messageAudience = [
    'PrivateMessage',
    'ReportMessage',
    'NonActiveMembersMessage',
    'ActiveMembersMessage',
    'OpenLeadsMessage',
    'LostLeadsMessage',
    'StaffMembersMessage',
];

export const SMS = 'sms';
export const PUSH = 'push';
export const EMAIL = 'email';
export const WHATSAPP = 'whatsapp';

export const autoMessageTypesObj = ({smsBalance}) => ({
    [PUSH]: {label: t('push-label'), id: PUSH, value: PUSH},
    [SMS]: {label: t('sms-balance', {balance: smsBalance ?? ''}), id: SMS, value: SMS},
    [EMAIL]: {label: t('emailType'), id: EMAIL, value: EMAIL},
    [WHATSAPP]: {label: t('whatsappType'), id: WHATSAPP, value: WHATSAPP}
})

export const fieldUpdateFunctionNames = {
    EVENT_SPACE: 'updateEventSpace',
    EVENT_STAFF: 'updateEventStaff',
    BOX_CATEGORY: 'updateBoxCategory',
    EVENT_TIME: 'updateEventTime',
    EVENT_SPACE_RELATION: 'updateEventSpaceRelation',
}

export const UNKNOWN_CHIP = 'unknown-chip';
export const IDENTIFIER_ERROR = 'IDENTIFIER_ERROR';

export const searchUserTypes = ['user', 'lead', 'union', 'freefit', 'coach', 'aggregator'];

export const IMMEDIATE = 'IMMEDIATE'
export const HOK = 'HOK'
export const TRIAL = 'TRIAL'

export const USER_FIELDS = 'user_fields';
export const USER_SITE_FIELDS = 'user_site_fields';
export const SITE_TRIAL_SETTINGS = 'site_trial_settings';
export const SITE_LEAD_FORM_SETTINGS = 'site_lead_form_settings'
export const SCHEDULE_SETTINGS = 'schedule_settings';
export const DEFAULTS = 'defaults';
export const HUGIM_FORM = 'hugim_form';
export const GROUP_FORM = 'group_form';
export const TRIAL_LIMIT_SETTING = 'trial_limit_settings';
export const MISSING_USER_NOTE_INDICATOR = 'missing_user_note_indicator';
export const CONFIRMATION_SETTINGS = 'confirmation_settings';
export const DOCTOR_JOURNAL_SETTINGS = 'doctor_journal_settings';
export const AVAILABILITY_REVEAL_TIME = 'availability_reveal_time'
export const CHARGE_SETTING = 'charge_setting';
export const WORKING_HOURS_SETTING = 'working_hours_setting';

export const seriesPaymentDBTranslate = {
    recurring: HOK,
    regular: IMMEDIATE,
    trial: TRIAL
}

export const customFieldTypes = {
    TEXT: 'text',
    SELECT: 'select',
    BOOLEAN: 'boolean',
    NUMBER: 'number',
    DATE: 'date',
    PHONE: 'phone'
}

export const userFieldsOptions = ['first_name', 'last_name', 'email', 'phone', 'personal_id', 'birthday', 'gender', 'source_fk', 'city', 'address', 'users_boxes_owner_id'];
export const userFieldsSiteOptions = ['first_name', 'last_name', 'email', 'phone', 'birthday', 'gender', 'personal_id'];
export const siteChargeOptions = {
    grow: ['card', 'bit', 'apple_pay', 'google_pay', 'bank_transfer', 'pay_box']
};
export const userTypes = ['member', 'lead'];
export const siteUserTypes = ['member', 'child', 'lead'];
export const boxSettingsProps = {
    [USER_FIELDS]: {fields: userFieldsOptions, flows: userTypes},
    [SITE_TRIAL_SETTINGS]: {},
    [USER_SITE_FIELDS]: {fields: userFieldsSiteOptions, flows: siteUserTypes},
}

export const textGeneratorTypes = {
    EVENT_TYPE: 'event type'
}

export const eventTypesForTextGenerator = {
    [CLASS]: 'group class',
    [APPOINTMENT]: 'personal session',
    [WORKSHOP]: 'workshop',
    [HUGIM]: 'workshop'
}
export const siteFormLeadFieldOptions = ['first_name', 'last_name', 'email', 'phone', 'comment']

export const familyArray = [0,2,4,5,1,3,6,7,8,9]; // IM SORRY FOR THAT

export const restrictions = {
    ADD_PRODUCT_TYPE: 'addProductType',
    ADD_SERVICE_TYPE: 'addServiceType',
    ADD_SESSION: 'addSession',
    ADD_CUSTOM_FIELD: 'addCustomField',
    ADD_SERIES_EVENT: 'addSeriesEvent',
    ADD_MEMBERSHIP_TYPE: 'addMembershipType',
    ADD_STAFF_MEMBER: 'addStaffMember',
}
export const createdStatusId = 1025 //i know this is gross
export const lostLeadStatusId = 1027 //i know this is gross too

export const RELATIVE = 'hug_relative'
export const FULL = 'hug_full'

export const multiPurchaseTypeToMtType = {
    [REPORT_ACTIONS.multiPunchCardPurchase]: MembershipTypes.SESSION,
    [REPORT_ACTIONS.multiPlanPurchase]: MembershipTypes.PLAN
}

export const messageTemplateScopes = {
    SCHEDULE: 'schedule',
    PENALTIES: 'penalties',
    NOTE: 'note'
}

export const manageTabs = {
    APPOINTMENT_USER: 'APPOINTMENT_USER',
    PAST_NOTES: 'PAST_NOTES'
}

export const paymentLogs = {
    successResponseLog: 'successResponse',
    submitLog: 'paymentSubmit',
    errorResponseLog: 'paymentErrorResponse',
    iframeLog: 'paymentIframeSrc',
    stopListeningResponseLog: 'stopListeningResponse',
    enterEventListenerLog: 'enterEventListener',
    noInitMessageLog: 'paymentNoInitMessage',
    gotInitMessageLog: 'paymentGotInitMessage',
    uuidPaymentLogError: 'uuidPaymentLogError',
    startedExecutionLog: 'startedExecutionLog',
    executionSuccessLog: 'executionSuccessLog'
}

export const VAT_PERCENTAGE = 0.18;

export const RIVHIT = 'rivhit';
export const ARBOX_INVOICES = 'arbox-invoices';

export const invoicesTypes = {
    [RIVHIT]: '1',
    [ARBOX_INVOICES]: '2'
};
const RECEIPT = 'receipt';
const TAX_INVOICE = 'tax-invoice';
const TAX_INVOICE_RECEIPT = 'tax-invoice-receipt';
const TRANSACTION_ACCOUNT = 'transaction-account';
const PRICE_QUOTE = 'price-quote';
const REFUND_INVOICE = 'refund-invoice';

export const documentTypes = [
    {name: RECEIPT, paramter: 'receipt', permission: 'createReceipt'},
    {name: TAX_INVOICE, paramter: 'tax_invoice', permission: 'createTaxInvoiceOrReceipt'},
    {name: TAX_INVOICE_RECEIPT, paramter: 'invoice_receipt_tax', permission: 'createTaxInvoiceReceipt'},
    {name: TRANSACTION_ACCOUNT, paramter: 'transaction_account', permission: 'createTransactionAccount'},
    {name: PRICE_QUOTE, paramter: 'price_quote', permission: 'createPriceQuote'},
    {name: REFUND_INVOICE, paramter: 'refund_invoice', permission: 'createRefundInvoice'},
];

export const documentFlowTypes = {
    INVOICE_PURCHASE: 'invoicePurchase',
    RECEIPT_PURCHASE: 'receiptPurchase',
    TRANSACTION_ACCOUNT_PURCHASE: 'transactionAccountPurchase',
    INVOICE_RECEIPT_PURCHASE: 'invoiceReceiptPurchase',
    PRICE_QUOTE_PURCHASE: 'priceQuotePurchase',
    REFUND_INVOICE_PURCHASE: 'refundInvoicePurchase',
}


export const HUG_FULL_BOOKING = 'HUG_FULL_BOOKING';
export const HUG_DAY_BOOKING = 'HUG_DAY_BOOKING';
export const HUG_PARTIAL_BOOKING = 'HUG_PARTIAL_BOOKING';